import { useEffect, useState } from "react";
import FetchError from "../interface/FetchError";
import { AxiosResponse } from "axios";
import apiService from "../services/api.service";

interface Chapter {
  id: number;
  title: string;
  number: number;
  completion_status: string;
}

interface Book {
  id: number;
  title: string;
}

const adminUseFetchBookChapters = (bookId: string) => {
  const [chapters, setChapters] = useState<Chapter[]>([]);
  const [book, setBook] = useState<Book | null>(null);
  const [error, setError] = useState<FetchError>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [chapterResponse, bookResponse] = await Promise.all([
          apiService.get<AxiosResponse>(`/chapters/?book_id=${bookId}`),
          apiService.get<AxiosResponse>(`/books/?book_id=${bookId}`),
        ]);
        const sortedChapters = chapterResponse.data.sort(
          (a: Chapter, b: Chapter) => a.number - b.number
        );

        setChapters(sortedChapters);
        setBook(bookResponse.data[0]);
      } catch (error) {
        if (error instanceof Error) {
          setError(error);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [bookId]);
  return { chapters, book, loading, error };
};

export default adminUseFetchBookChapters;
